import Vue from 'vue';
import VueI18n from 'vue-i18n';
import EN from 'element-ui/lib/locale/lang/en';
import Zh_CN from 'element-ui/lib/locale/lang/zh-CN';
import zh_HK from 'element-ui/lib/locale/lang/zh-TW';
import ENLocale from './en-US';
import ZH_CNLocale from './zh-CN';
import zhTWLocal from './zh-HK';
import deLocal from './de-DE';
import itLocal from './it-IT';
import ukLocal from './uk-UA';
import request from "../utils/request";

Vue.use(VueI18n);

const tlLocal = localStorage.getItem('Accept-Language') || 'en-US';
console.log('11-22 刷新页面-语言:', tlLocal);

// 1. 先同步创建 i18n 实例，使用本地语言包
const i18n = new VueI18n({
  locale: tlLocal,
  messages: {
    'zh-CN': { ...ZH_CNLocale, ...Zh_CN },
    'en-US': { ...ENLocale, ...EN },
    'zh-HK': { ...zhTWLocal, ...zh_HK },
    'de-DE': { ...deLocal },
    'it-IT': { ...itLocal },
    'uk-UA': { ...ukLocal },
    'fr-FR': {},
  },
  fallbackLocale: 'zh-CN',
});

// 2. 异步加载远程语言包
const loadRemoteMessages = async () => {
  try {
    const res = await request({ 
      method: 'get', 
      url: `/system/i18nMessage/getAllMessageSource?app=haier-energy-web&module=COMMON&language=${tlLocal}` 
    });
    
    console.log('11-22-请求了接口成功-', res);
    
    if (res?.data?.code === 200) {
      const remoteData = res.data.data;
      let localeKey = '';
      
      // 确定要更新哪个语言包
      switch (tlLocal) {
        case 'zh-CN':
          localeKey = 'zh-CN';
          i18n.mergeLocaleMessage(localeKey, { ...remoteData });
          break;
        case 'en-US':
          localeKey = 'en-US';
          i18n.mergeLocaleMessage(localeKey, { ...remoteData });
          break;
        case 'zh-HK':
          localeKey = 'zh-HK';
          i18n.mergeLocaleMessage(localeKey, { ...remoteData });
          break;
        case 'de-DE':
          localeKey = 'de-DE';
          i18n.mergeLocaleMessage(localeKey, { ...remoteData });
          break;
        case 'it-IT':
          localeKey = 'it-IT';
          i18n.mergeLocaleMessage(localeKey, { ...remoteData });
          break;
        case 'uk-UA':
          localeKey = 'uk-UA';
          i18n.mergeLocaleMessage(localeKey, { ...remoteData });
          break;
        case 'fr-FR':
          localeKey = 'fr-FR';
          i18n.mergeLocaleMessage(localeKey, { ...remoteData });
          break;
        default:
          i18n.mergeLocaleMessage('en-US', { ...remoteData });
      }
    } else {
      console.error('11-22-后台返回错误:', res);
    }
  } catch (error) {
    console.error('11-22-加载远程语言包失败:', error);
  }
};

// 立即开始加载远程语言包（不阻塞应用启动）
loadRemoteMessages();

export default i18n;